// extracted by mini-css-extract-plugin
export default {"mainContainer":"PopupCallback_mainContainer__hUEWN","loaderContainer":"PopupCallback_loaderContainer__dFjMO"};